
//MERCADOPAGO
//export const KEYMP = 'TEST-3024688312822652-122717-ba31d945e91bee75ec582c126b5f9fd9-693902195';
//export const KEYMP = 'APP_USR-2766994262266042-122712-912f089008ab9b530f002b085b217e40-1482300';
export const KEYMP = 'APP_USR-1988184707646324-052511-e932892c774a00b5cb11ec674da24cf9-1482300'

//BASEURL
export const BASE_URL_SITE = "https://programaengfood.com.br/" //"http://localhost:3000/"